var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirm",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShow,
          expression: "isShow"
        }
      ],
      attrs: {
        showMask: true,
        title: _vm.$t("tradeMining.addTitle"),
        closeIcon: true,
        close: _vm.close,
        leftBtnClick: _vm.staking,
        leftBtnTxt: _vm.$t("tradeMining.addBtn"),
        singleBtn: true,
        btnUnuse: !_vm.canOrder
      }
    },
    [
      _c("div", { staticClass: "__row" }, [
        _c("div", { staticClass: "__row_t" }, [
          _vm._v(_vm._s(_vm.$t("tokenCard.heads.availableExAmount")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__input_row __unuse_input __bold" }, [
          _c("img", {
            staticClass: "__icon",
            attrs: { src: _vm.viteTokenInfo ? _vm.viteTokenInfo.icon : "" }
          }),
          _vm._v("dSLS\n            "),
          _c("span", { staticClass: "__right" }, [
            _vm._v(_vm._s(_vm.exViteBalance))
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "__row" },
        [
          _c("div", { staticClass: "__row_t" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.$t("wallet.sum")) + "\n            "
            ),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.amountErr,
                    expression: "amountErr"
                  }
                ],
                staticClass: "__err"
              },
              [_vm._v(_vm._s(_vm.amountErr))]
            )
          ]),
          _vm._v(" "),
          _c(
            "vite-input",
            {
              attrs: {
                valid: _vm.testAmount,
                placeholder: _vm.$t("tradeMining.addPlaceHolder")
              },
              on: { input: _vm.noAll },
              model: {
                value: _vm.amount,
                callback: function($$v) {
                  _vm.amount = $$v
                },
                expression: "amount"
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "all-wrapper",
                  attrs: { slot: "after" },
                  on: { click: _vm.all },
                  slot: "after"
                },
                [
                  _c("span", { staticClass: "all" }, [
                    _vm._v(_vm._s(_vm.$t("tradeAssets.all")))
                  ])
                ]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "__hint distance" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("tradeMining.addHint1")))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "__hint" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("tradeMining.addHint2")))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "__hint" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("tradeMining.addHint3")))])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }